export function CeleroTokenizerCtrl (
  $element,
  $scope,
  $translate,
  Celero,
  messages
) {
  $scope.celero = new Celero();
  $scope.url;

  $scope.init = function () {
    $scope.celero.getUrl().then(url => {
      $scope.url = url;

      return $scope.celero.getPublicKey();
    })
    .then(key => {
      $scope.tokenizer = new Tokenizer({
        apikey   : key,
        container: $element.find('#tokenizer')[0],
        url      : $scope.url,
        submission (response) {
          switch (response.status){
            case 'success':
              $scope.process(response);
              break;
            case 'validation':
              messages.error($translate.instant('COMPANY_SPACE.INTEGRATIONS.CELERO.INVALID_CREDIT_CARD'));
              break;
            case 'failed':
              messages.error(response.msg);
              break;
            default:
              messages.error('Unknown error. Please try again.');
          }
        }
      });

      $scope.tokenizer.create();
    });
  };

  $scope.process = function (response) {
    const amount = $scope.celero.getPaymentTotal($scope.payment);

    $scope.celero.process({
      amount,
      invoice_id   : $scope.invoice.id,
      payment_id   : $scope.payment.id,
      payment_token: response.token
    })
    .then(() => {
      $scope.$emit('celeroSuccess');
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.$on('celeroSubmit', () => {
    $scope.tokenizer.submit();
  });

  $scope.init();
}
